/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Practice_Session_Voice_FailedInputs */



/**
* | output |
* | --- |
* | "We could not connect. Check your microphone and your internet connection, then try again." |
*
* @param {Practice_Session_Voice_FailedInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const practice_session_voice_failed = /** @type {((inputs?: Practice_Session_Voice_FailedInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Practice_Session_Voice_FailedInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("We kregen geen verbinding. Controleer je microfoon en internetverbinding, en probeer het opnieuw.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("La connexion n'a pas abouti. Vérifiez votre micro et votre connexion internet, puis réessayez.")
	return /** @type {LocalizedString} */ ("We could not connect. Check your microphone and your internet connection, then try again.")
});